import React, { useEffect, useState } from "react";
import { mediaUrl } from "../lib/api";

export const Avatar = ({ user, size = 40, className = "" }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
  }, [user?.avatar_url]);
  const initial = (user?.name || user?.email || "?").trim().charAt(0).toUpperCase();
  const style = { width: size, height: size };

  if (user?.avatar_url && !failed) {
    return (
      <img
        src={mediaUrl(user.avatar_url)}
        alt={user?.name || "Profile"}
        referrerPolicy="no-referrer"
        onError={() => setFailed(true)}
        style={style}
        className={`rounded-full object-cover ${className}`}
        data-testid="user-avatar"
      />
    );
  }

  return (
    <div
      style={style}
      className={`rounded-full bg-[#1A4331] text-white flex items-center justify-center font-semibold ${className}`}
      data-testid="user-avatar-fallback"
    >
      {initial}
    </div>
  );
};
